//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  applySnapshot,
  cast,
  flow,
  getEnv,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { SearchStore } from "./jobs/search";

const MessageStore = types.model("Message", {
  status: types.optional(types.boolean, false),
  text: types.optional(types.string, ""),
  error: types.optional(types.boolean, false),
});
const RequestInstance = types.model("RequestInstance", {
  requestSlug: types.optional(types.string, ""),
  requestSubjects: types.optional(types.string, ""),
  clientName: types.optional(types.string, ""),
  clientEmail: types.optional(types.string, ""),
  requestUrl: types.optional(types.string, ""),
  isParentRequest: types.optional(types.boolean, false),
  // hourlyBudget: types.optional(types.number, 0),
  // totalBudget: types.optional(types.number, 0),
});
const MatchedSubject = types.model("MatchedSubject", {
  name: types.string,
  active: types.boolean,
  url: types.string,
});
export const AdditionalInfo = types
  .model("AdditionalInfo", {
    budget: types.optional(types.number, 0),
    no_of_lessons: types.optional(types.number, 0),
  })
  .views((self) => {
    return {
      get isValid() {
        return self.budget > 0 && self.no_of_lessons > 0;
      },
    };
  })
  .actions((self) => {
    function updateData(result) {
      Object.keys(result).forEach((x) => {
        if (x === "budget") {
          self.budget = parseFloat(result[x]);
        } else {
          self.no_of_lessons = parseInt(result[x]);
        }
      });
    }
    return {
      updateData,
    };
  });
const RequestPool = types
  .model("RequestPool", {
    pool_id: types.maybeNull(types.number),
    full_name: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    approved: types.optional(types.boolean, false),
    teaches_all: types.optional(types.boolean, false),
    matched_subjects: types.optional(types.array(MatchedSubject), []),
    default_subject: types.optional(types.maybeNull(types.string), ""),
    phone_no: types.maybeNull(types.string),
    address: types.maybeNull(types.string),
    additionalInfo: types.optional(AdditionalInfo, {}),
    cost: types.optional(types.maybeNull(types.string), ""),
  })
  .actions((self) => {
    return {
      toggleApproved() {
        self.approved = !self.approved;
      },
      initializeBudget(totalBudget: number) {
        if (self.additionalInfo.budget === 0) {
          self.additionalInfo.updateData({ budget: totalBudget });
          console.log(getSnapshot(self.additionalInfo));
        }
      },
    };
  });

export const OldRequestStore = types
  .model("OldRequestStore", {
    loading: types.optional(types.boolean, true),
    message: types.optional(MessageStore, {}),
    typing: types.optional(types.boolean, false),
    teachAllSubjects: types.optional(types.boolean, false),
    split_count: types.optional(types.number, 0),
    totalBudget: types.maybeNull(types.union(types.string, types.number)),
    convertedTotalBudget: types.maybeNull(types.union(types.string, types.number)),
    selectCurrency: types.maybeNull(types.string),
    hourlyBudget: types.maybeNull(types.union(types.string, types.number)),
    // convertedHourlyBudget: types.maybeNull(types.union(types.string, types.number)),
    sending: types.optional(types.boolean, false),
    isOneActive: types.optional(types.boolean, false),
    instance: types.optional(RequestInstance, {}),
    requestPool: types.optional(types.array(RequestPool), []),
    searchStore: types.optional(SearchStore, {}),
    walletBalance: types.optional(types.number, 0),
    changed: types.optional(types.boolean, false),
  })
  .views((self) => {
    return {
      get canSubmit() {
        if (self.instance.isParentRequest) {
          let approvedTutors = self.requestPool.filter((o) => o.approved);
          if (
            self.teachAllSubjects ||
            approvedTutors.length === 1 ||
            self.split_count >= 1
          ) {
            let first = approvedTutors[0];
            const _approvedTutors = self.split_count === 1 ? [approvedTutors[0]] : approvedTutors;
            const approvedTutorsBudget = _approvedTutors.reduce((total, tutor) => total + tutor.additionalInfo.budget, 0)
            return (
              approvedTutorsBudget ===
              parseFloat(self.totalBudget as any) &&
              first.additionalInfo.no_of_lessons > 0
            );
          }
          let totalPayments = approvedTutors.reduce(
            (a, b) => a + b.additionalInfo.budget,
            0,
          );
          return (
            totalPayments === parseFloat(self.totalBudget as any) &&
            approvedTutors[0].additionalInfo.no_of_lessons > 0
          );
        }
        return true;
      },
      get splitRequests() {
        return self.searchStore.splitRequests || [];
      },
      get requestBudget() {
        return self.searchStore.generatePaymentInfo().totalTuition;
      },
      get userSubjects() {
        return this.splitRequests
          .map((o) => o.subjectGroup)
          .flat()
          .join(",");
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv(self);
    const sendProfileToClient = flow(function* sendProfileToClient(e) {
      e.preventDefault();
      if (self.canSubmit) {
        self.sending = true;
        try {
          yield adapter.sendProfileToClient(self.instance.requestSlug, {
            setState,
          });
          self.sending = false;
        } catch (error) {
          self.sending = false;
          console.log(error);
        }
      } else {
        updateMsg(
          true,
          "Ensure that pool budget matches totalBudget and lesson count is set",
          true,
        );
      }
    });
    function setState(values) {
      let existing = { ...getSnapshot(self) };
      Object.keys(values).forEach((item) => {
        existing[item] = values[item];
      });
      applySnapshot(self, existing);
    }
    const fetchTutors = flow(function* fetchTutors() {
      try {
        yield adapter.getTutorsFromPool(
          self.instance.requestSlug,
          self.totalBudget,
          {
            setState,
          },
        );
        // self.requestPool.forEach(o => {
        //   o.initializeBudget(parseFloat(self.totalBudget as any))
        // })
      } catch (error) {
        console.log(error);
      }
    });
    const updateBudget = flow(function* updateBudget(new_budget) {
      try {
        yield adapter.updateBudgetFunc(self.instance.requestSlug, new_budget, {
          setState,
        });
      } catch (error) {
        console.log(error);
      }
    });
    const convertBudget = flow(function* convertBudget(new_converted_budget) {
      try {
        yield adapter.convertBudgetFunc(self.instance.requestSlug, new_converted_budget, {
          setState,
        });
      } catch (error) {
        console.log(error);
      }
    });
    const updateCurrency = flow(function* updateCurrency(new_currency) {
      try {
        yield adapter.updateCurrencyFunc(self.instance.requestSlug, new_currency, {
          setState,
        });
      } catch (error) {
        console.log(error);
      }
    });
    const updateMsg = (status, text, error) => {
      console.log(status, text, error);
      setState({ message: { status, text, error } });
    };
    const updateTutorPrice = flow(
      function* updateTutorPrice(price, poolId, component) {
        try {
          yield adapter.updatePoolInstance(
            poolId,
            component,
            "updatePrice",
            { cost: price },
            updateMsg,
          );
        } catch (error) {
          console.log(error);
        }
      },
    );
    const changeDefaultSubject = flow(
      function* changeDefaultSubject(subject_name, poolId, component) {
        try {
          yield adapter.updatePoolInstance(
            poolId,
            component,
            "updateDefaultSubject",
            { default_subject: subject_name },
            updateMsg,
          );
        } catch (error) {
          console.log(error);
        }
      },
    );
    const handleToggleTutorApproval = flow(
      function* handleToggleTutorApproval(poolId, approval, component) {
        try {
          yield adapter.handleToggleApprovalFunc(
            poolId,
            approval,
            component,
            updateMsg,
          );
          let foundPool = self.requestPool.find((o) => o.pool_id === poolId);
          foundPool.toggleApproved();
        } catch (error) {
          console.log(error);
          // updateMsg(false, "Error ", true);
        }
      },
    );
    // for new flow
    const initializeRequestInstance = flow(function* initializeRequestData() {
      self.loading = true;
      try {
        let {
          requestData,
          tutorsData = [],
          specialities = [],
          academicInfo,
          farePerKM = 0,
          distancePerThreshold = 0,
        } = yield adapter.initializeRequestData(self.instance.requestSlug);
        yield self.searchStore.initializeRequestStore(
          requestData,
          tutorsData,
          specialities,
          academicInfo,
        );
        self.searchStore.setFareData(farePerKM, distancePerThreshold);
        self.loading = false;
      } catch (error) {
        self.loading = false;
      }
    });
    const addTutorToPool = flow(
      function* addTutorToPool(tutorEmail, activeSubject) {
        yield adapter.addTutorToPool(tutorEmail, activeSubject);
      },
    );
    const updateAdditionalInfo = flow(
      function* updateAdditionalInfo(pool_id, component, data) {
        const pool = self.requestPool.find((o) => o.pool_id === pool_id);
        if (pool) {
          pool.additionalInfo.updateData(data);
          if (pool.additionalInfo.isValid) {
            yield adapter.updateAdditionalInfo(
              pool_id,
              component,
              "updateAdditionalInfo",
              getSnapshot(pool.additionalInfo),
              updateMsg,
            );
          }
        }
      },
    );
    const updateSplitCount = flow(function* updateSplitCount(value) {
      self.split_count = parseInt(value);
      yield adapter.updateSplitCount(
        self.instance.requestSlug,
        self.split_count,
        {
          setState,
        },
        updateMsg,
      );
    });
    return {
      updateSplitCount,
      updateAdditionalInfo,
      addTutorToPool,
      sendProfileToClient,
      fetchTutors,
      resetState() {
        self.requestPool = cast([]);
        self.loading = true;
      },
      setState,
      updateBudget,
      convertBudget,
      updateCurrency,
      updateTutorPrice,
      changeDefaultSubject,
      updateMsg,
      handleToggleTutorApproval,
      initializeRequestInstance,
    };
  });

const Tutor = types.model("Tutor", {
  email: types.optional(types.string, ""),
});

export const BookGroupLessonStore = types
  .model("BookGroupLessonStore", {
    email: types.optional(types.string, ""),
    amount: types.optional(types.string, ""),
    message: types.optional(MessageStore, {}),
    loading: types.optional(types.boolean, false),
    tutor: types.maybeNull(Tutor),
    bookingSlug: types.maybeNull(types.string),
    paid: types.maybeNull(types.number),
  })
  .views((self) => ({
    get foundTutor() {
      return self.tutor;
    },
    get booked() {
      return self.bookingSlug;
    },
    get amountToBePaid() {
      return 0.75 * parseFloat(self.amount);
    },
  }))
  .actions((self) => {
    const adapter = getEnv(self);

    const setEmail = (value) => {
      self.email = value;
    };

    const setAmount = (value) => {
      self.amount = value;
    };

    const search = flow(function* search() {
      applySnapshot(self, { email: self.email });
      self.loading = true;
      try {
        const tutor = yield adapter.search(self.email);
        self.tutor = { email: tutor.email };
      } catch (error) {
        self.message = {
          status: true,
          text: "Search failed",
          error: true,
        };
      }
      self.loading = false;
    });

    const bookTutor = flow(function* bookTutor() {
      self.loading = true;
      try {
        const booking = yield adapter.bookTutor(
          self.foundTutor.email,
          self.amount,
        );
        self.bookingSlug = booking.slug;
      } catch (error) {
        self.message = {
          status: true,
          text: "Booking failed",
          error: true,
        };
      }
      self.loading = false;
    });

    const payTutor = flow(function* payTutor() {
      self.loading = true;
      try {
        const result = yield adapter.payTutor(
          self.foundTutor.email,
          self.bookingSlug,
          self.amountToBePaid,
        );
        self.paid = result.amount;
        self.message = {
          status: true,
          text: "Payment Successful",
          error: false,
        };
      } catch (error) {
        self.message = {
          status: true,
          text: "Payment failed",
          error: true,
        };
      }
      self.loading = false;
    });

    const refreshStore = () => {
      applySnapshot(self, {});
    };

    return {
      setEmail,
      setAmount,
      search,
      bookTutor,
      payTutor,
      refreshStore,
    };
  });
